<!-- 
  详情页 - 客户 上下级客户
  props:
    id: 详情id
 -->

<template>
	<div class="parent-and-child">
    <dl class="box">
      <dt class="title">上级客户</dt>
      <dd class="item" v-if="parent.name">
        <h5 class="name">{{parent.name}}<em class="status">{{parent.type}}</em></h5>
        <p class="text">联系电话：{{parent.phoneArray | getFirst}}</p>
        <p class="text">主负责人：{{parent.manager}} | 最后访问时间：{{parent.lastConnectTime}}</p>
        <a href="javascript:;" v-if="isDel === 0" class="del" @click="del(parent.id, 1)">删除</a>
      </dd>
    </dl>
    <el-button type="text" v-if="!parent.name && isDel === 0" @click="addCustomer(1)">添加上级客户</el-button>

		<dl class="box">
      <dt class="title">下级客户</dt>
      <dd class="item" v-for="item in children">
        <h5 class="name">{{item.name}}<em class="status">{{item.type}}</em></h5>
        <p class="text">联系电话：{{item.phoneArray | getFirst}}</p>
        <p class="text">主负责人：{{item.manager}} | 最后访问时间：{{item.lastConnectTime}}</p>
        <a href="javascript:;" class="del" @click="del(item.id, 0)" v-if="isDel === 0">删除</a>
      </dd>
    </dl>
    <el-button type="text" @click="addCustomer(0)" v-if="isDel === 0">添加下级客户</el-button>

    <el-dialog :title="modalTitle" :visible.sync="dialogVisible" :modal="false" width="550px">
      <el-form label-width="120px" style="margin-right:50px;">
        <el-form-item label="选择客户">
        <el-autocomplete
          v-model="customer"
          class="v-autocomplete"
          :fetch-suggestions="search"
          placeholder="搜索或选择"
          @select="handleChange"
        ></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
    <div class="v-modal" v-show="dialogVisible"></div>

	</div>
</template>

<script>
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'
let lazy

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      isDel: undefined,
      parent: {},
      children: [],
      dialogVisible: false,
      modalTitle: '',
      customer: '',
      selected: {},
      type: 0
    }
  },
  methods: {
    getList () {
      let url = '/customerApi/getParentAndChildCustomer.html'
      let params = {
        customerId: this.id
      }
      api.post(url, params, (data) => {
        this.parent = data.parentObj
        this.children = data.childArray
        this.isDel = data.isDel
      })
    },
    search (key, cb) {
      window.clearTimeout(lazy)
      lazy = window.setTimeout(() => { this.getItem(key, cb) }, 300)
    },
    getItem (key, cb) {
      let url = '/customerApi/getCustomers.html'
      let params = {
        nameLike: key || ''
      }
      api.post(url, params, (data) => {
        cb(data.result)
      })
    },
    handleChange (item) {
      this.selected = item
    },
    // 打开弹窗
    addCustomer (type) {
      this.type = type
      this.modalTitle = `选择${type ? '上' : '下'}级客户`
      this.dialogVisible = true
    },
    handleSubmit () {
      if (this.selected.value !== this.customer) {
        Message({
          type: 'error',
          message: '找不到该客户，请重新选择!'
        })
      } else {
        let url, params
        if (this.type) {
          url = '/customerApi/addParentCustomer.html'
          params = {
            customerId: this.id,
            parentCustomerId: this.selected.id
          }
        } else {
          url = '/customerApi/addChildCustomer.html'
          params = {
            customerId: this.id,
            childCustomerId: this.selected.id
          }
        }
        api.post(url, params, (data) => {
          const that = this
          Message({
            type: 'success',
            message: data.msg || '操作成功!',
            duration: 1000,
            onClose () {
              that.getList()
              that.dialogVisible = false
            }
          })
        })
      }
    },
    del (id, type) {
      MessageBox.confirm(`确认删除吗?`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delItem(id, type)
      }).catch(() => {})
    },
    delItem (id, type) {
      let url, params
      if (type) {
        url = '/customerApi/deleteParentCustomer.html'
        params = {
          customerId: this.id
        }
      } else {
        url = '/customerApi/deleteChildCustomer.html'
        params = {
          customerId: this.id,
          childCustomerId: id
        }
      }
      api.post(url, params, (data) => {
        const that = this
        Message({
          type: 'success',
          message: data.msg || '删除成功!',
          duration: 1000,
          onClose () {
            that.getList()
            that.dialogVisible = false
            that.customer = ''
          }
        })
      })
    }
  },
  filters: {
    getFirst (arr) {
      if (arr && arr.length) {
        return arr[0].telNum
      } else {
        return '无'
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';

  .parent-and-child {
    padding-left: 10px;
    .box {
      padding: 14px 0 5px;
      .title {
        color: @bg-orange;
        font-size: 14px;
        line-height: 1;
        padding-left: 20px;
        border-left: 13px solid @bg-orange;
      }
      .item {
        margin-top: 15px;
        border: 1px solid #EAEAEA;
        padding: 12px 12px 0;
        position: relative;
        line-height: 1;
        .name {
          font-size: 15px;
          padding-bottom: 12px;
          color: #000;
          .status {
            margin-left: 6px;
            font-size: 12px;
            padding: 3px 6px;
            font-style: normal;
            color: #fff;
            border-radius: 2px;
            background-color: @bg-orange;
          }
        }
        .text {
          font-size: 13px;
          padding-bottom: 12px;
        }
        .del {
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -6px;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .v-autocomplete {
      width: 300px;
    }
    .el-dialog--small {
      width: 600px;
    }
  }
</style>


// WEBPACK FOOTER //
// parent-and-child.vue?7b7f5e50